<p>user-delete works!</p>
